import { useAPI, useAsyncHandler } from '~/hooks/common';

import { API_ENDPOINT } from '~/constants';

import type { TypeErrorResponseData } from '~/types/common.types';
import type { TypePostShippingLabelsDownloadParams } from '~/types/delivery-agency.types';

const usePostShippingLabelsDownload = () => {
  const { runDownloadAsync } = useAsyncHandler();

  const postShippingLabelsDownload = useAPI<TypePostShippingLabelsDownloadParams>({
    endpoint: API_ENDPOINT.DELIVERY_AGENCY.POST_SHIPPING_LABELS_EXCEL_DOWNLOAD,
    method: 'post',
    responseType: 'blob',
  });

  const requestShippingLabelsDownload = async (
    params: TypePostShippingLabelsDownloadParams,
    {
      onSuccess,
      onError,
    }: {
      onSuccess?: () => void;
      onError?: (error: TypeErrorResponseData['error']) => void;
    }
  ) =>
    runDownloadAsync(() => postShippingLabelsDownload({ params }), {
      onSuccess,
      onError: (error: TypeErrorResponseData['error']) => onError?.(error),
    });

  return { requestShippingLabelsDownload };
};

export default usePostShippingLabelsDownload;
